// extracted by mini-css-extract-plugin
export default {"DollarDiscountItem":"DollarDiscountItem_DollarDiscountItem__+LB1M","PriceWrapper":"DollarDiscountItem_PriceWrapper__NL4WD"};